import moment from 'moment';
import 'underscore';
import arrayUtils from 'tradera-apps/syi/script/app_react/utils/array-utils';

var initialState = {
    isLoading: false
};

export default (state, action) => {
    state = state || initialState;
    var newDraft = null;
    switch (action.type) {
        case 'SET_DRAFT_PROPERTIES': {
            const referenceIsReadonly =
                action.draft.reference &&
                action.draft.reference.indexOf('Sello artnr') >= 0;
            newDraft = _.assign(initialState, action.payload, {
                draftId: action.draft.draftId,
                draftReason: action.draft.draftReason,
                memberId: action.draft.memberId,
                itemId: action.draft.itemId,
                restart: action.draft.restart,
                publishedPromoted: action.draft.publishedPromoted,
                publishedHighlighted: action.draft.publishedHighlighted,
                createdDate: action.draft.createdDate,
                lastModifiedDate: action.draft.lastModifiedDate,
                publishedDate: action.draft.publishedDate,
                publishedAsItemType: action.draft.publishedAsItemType,
                reference: action.draft.reference,
                referenceIsReadonly: referenceIsReadonly,
                additionalDescriptions: action.draft.additionalDescriptions,
                metadata: action.draft.metadata,
                templateId: action.draft.templateId,
                templateName: action.draft.templateName,
                version: action.draft.version,
                isNewDraft: !action.draft.draftId
            });
            break;
        }
        case 'SET_DRAFT_ID':
            newDraft = _.assign({}, state, { draftId: action.payload });
            break;
        case 'SET_RESTART':
            newDraft = _.assign({}, state, { restart: action.payload });
            break;
        case 'DISABLE_RESTART':
            newDraft = { ...state, restart: false };
            break;
        case 'SET_REFERENCE':
            newDraft = _.assign({}, state, { reference: action.payload });
            break;
        case 'ADD_ADDITIONAL_DESCRIPTION':
            var newAdditionalDescriptions = arrayUtils.shallowCopyArrayObjects(
                state.additionalDescriptions || []
            );
            newAdditionalDescriptions.push({ message: action.payload });
            newDraft = _.assign({}, state, {
                additionalDescriptions: newAdditionalDescriptions
            });
            break;
        case 'SET_DRAFT_REASON':
            newDraft = _.assign({}, state, { draftReason: action.payload });
            break;
        case 'SET_DRAFT_VERSION':
            newDraft = _.assign({}, state, { version: action.payload });
            break;
        case 'RESET_DRAFT':
            newDraft = { ...initialState };
            break;
        case 'SET_DRAFT_IS_LOADING':
            newDraft = { ...state, isLoading: action.payload };
            break;
        default:
            return state;
    }
    if (!_.isEqual(state, newDraft)) {
        newDraft.lastModifiedDate = moment().toISOString();
    }
    return newDraft;
};

/**
TODO: Do this:

import arrayUtils from '../../utils/array-utils';
import { createReducer } from '@reduxjs/toolkit';

var initialState = {};

export default createReducer(initialState, {
    SET_DRAFT_PROPERTIES: (state, action) => {
        const referenceIsReadonly =
            action.draft.reference &&
            action.draft.reference.indexOf('Sello artnr') >= 0;

        state = { ...action.draft, referenceIsReadonly };
    },
    SET_DRAFT_ID: (state, action) => {
        state.draftId = action.payload;
    },
    SET_RESTART: (state, action) => {
        state.restart = action.payload;
    },
    SET_REFERENCE: (state, action) => {
        state.reference = action.payload;
    },

    ADD_ADDITIONAL_DESCRIPTION: (state, action) => {
        var newAdditionalDescriptions = arrayUtils.shallowCopyArrayObjects(
            state.additionalDescriptions || []
        );
        newAdditionalDescriptions.push({ message: action.payload });
        state.additionalDescriptions = newAdditionalDescriptions;
    },

    SET_DRAFT_REASON: (state, action) => {
        state.draftReason = action.payload;
    },

    SET_DRAFT_VERSION: (state, action) => {
        state.version = action.payload;
    },

    RESET_DRAFT: () => {
        return { ...initialState };
    }
});

 */
